import React, { useEffect, useState } from 'react'
import './SelectFarm.scss'
import { func, array, bool } from 'prop-types'
import swal from 'sweetalert'

const SelectFarm = ({ setFarm, setUserLandNid, userFarm, inputDisable }) => {
  // defaultValue Selected
  const [selected, setSelected] = useState('')
  useEffect(() => {
    if (userFarm !== null && userFarm !== undefined) {
      if (userFarm.length > 0) {
        userFarm && setUserLandNid(userFarm[0].nid)
        userFarm &&
          setFarm(userFarm.filter((farm) => farm.nid === userFarm[0].nid))
        // defaultValue Selected
        userFarm && setSelected(userFarm[0].nid)
      } else {
        swal(
          'El usuario no tiene una finca asignada',
          'porfavor comuniquese con el administador de la aplicación',
          'warning'
        )
      }
    }
  }, [userFarm])
  const handleFarm = (e) => {
    setUserLandNid(e.target.value)
    setFarm(userFarm.filter((farm) => farm.nid === e.target.value))
    setSelected(e.target.value)
  }
  return (
    <div className="select__farm">
      <h2 className="select__farm--title select__farm--titleFarm">Finca</h2>
      <div>
        <select
          disabled={inputDisable}
          onChange={(e) => handleFarm(e)}
          className="select__farm--select"
          value={selected}
        >
          {userFarm &&
            userFarm.map((e, i) => (
              <option key={e.nid} value={e.nid}>
                {e.field_name}
              </option>
            ))}
        </select>
      </div>
    </div>
  )
}

SelectFarm.propTypes = {
  userFarm: array,
  setUserLandNid: func,
  setFarm: func,
  inputDisable: bool
}

export default SelectFarm
